import { render, staticRenderFns } from "./shortChain.vue?vue&type=template&id=c8831480&"
import script from "./shortChain.vue?vue&type=script&lang=js&"
export * from "./shortChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports